var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          ref: "renewalFormRef",
          staticClass: "login__form",
          model: {
            value: _vm.dtForm,
            callback: function($$v) {
              _vm.dtForm = $$v
            },
            expression: "dtForm"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-xs-left" },
            [
              _c("label", {
                staticClass: "primary--text text-uppercase login--label",
                domProps: {
                  textContent: _vm._s(_vm.$t(_vm.lblSetting.lblNewPassword))
                }
              }),
              _vm._v(" "),
              _c(
                "v-text-field",
                {
                  attrs: {
                    type: _vm.dtPasswordMode,
                    rules: _vm.dtRules.passwordRules,
                    placeholder: _vm.$t(
                      _vm.lblSetting.lblNewPasswordPlaceholder
                    )
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleRenewPassword($event)
                    }
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                },
                [
                  _vm.password
                    ? _c("template", { slot: "append" }, [
                        _c(
                          "a",
                          {
                            staticClass: "login--no-decoration",
                            attrs: { href: "javascript:void(0);" },
                            on: { click: _vm.handleShowPassword }
                          },
                          [_c("v-icon", [_vm._v("remove_red_eye")])],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-xs-left" },
            [
              _c("label", {
                staticClass: "primary--text text-uppercase login--label",
                domProps: {
                  textContent: _vm._s(_vm.$t(_vm.lblSetting.lblConfirmPassword))
                }
              }),
              _vm._v(" "),
              _c(
                "v-text-field",
                {
                  attrs: {
                    type: _vm.dtConfirmPasswordMode,
                    rules: _vm.dtRules.confirmationPasswordRules,
                    placeholder: _vm.$t(
                      _vm.lblSetting.lblNewConfirmPasswordPlaceholder
                    )
                  },
                  on: {
                    keyup: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleRenewPassword($event)
                    }
                  },
                  model: {
                    value: _vm.confirmedPassword,
                    callback: function($$v) {
                      _vm.confirmedPassword = $$v
                    },
                    expression: "confirmedPassword"
                  }
                },
                [
                  _vm.confirmedPassword
                    ? _c("template", { slot: "append" }, [
                        _c(
                          "a",
                          {
                            staticClass: "login--no-decoration",
                            attrs: { href: "javascript:void(0);" },
                            on: { click: _vm.handleShowConfirmPassword }
                          },
                          [_c("v-icon", [_vm._v("remove_red_eye")])],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "login--button",
              attrs: {
                color: "turquoise",
                block: "",
                loading: _vm.dtIsLoading,
                disabled: !_vm.dtForm
              },
              on: { click: _vm.handleRenewPassword }
            },
            [
              _c("span", { staticClass: "login--button-text primary--text" }, [
                _vm._v(_vm._s(_vm.$t("LBL_CONFIRM")))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.dtError || _vm.dtSecond
            ? _c(
                "span",
                { staticClass: "login-text" },
                [
                  _vm.dtSecond
                    ? [
                        _vm._v(
                          "\n        Redirection automatique vers la page de connexion après " +
                            _vm._s(_vm.dtSecond) +
                            " secondes\n      "
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "login--signup",
                      attrs: { href: "javascript:void(0);" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("BTN_LOGIN")) + "\n      "
                      )
                    ]
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtError
        ? _c(
            "v-alert",
            {
              staticStyle: { "margin-top": "5%", width: "45vh" },
              attrs: {
                value: true,
                color: "error",
                icon: "warning",
                outline: ""
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.dtError.message) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62f68e76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f68e76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/forgot-password-renew/template.html
// module id = null
// module chunks = 